import {MathJax, MathJaxContext} from "better-react-mathjax";
import {isNullOrUndefined} from "../../../services/Validator";

export default function DetailedCourseExampleQuestionText({exampleQuestion}) {
    // Used in DetailedCourseLevelAKnowledgeExample to display
    // exampleQuestion text

    // BUILD
    if (isNullOrUndefined(exampleQuestion))
        return null
    return (
        <div className={"w-full text-center px-[12px] mt-[16px]"}>
            <MathJaxContext>
                <MathJax inline dynamic>
                    <span className="whitespace-pre-line font-bold text-[18px] text-white">
                        {exampleQuestion}
                    </span>
                </MathJax>
            </MathJaxContext>
        </div>
    );
}